// Foundation
import { Foundation } from 'foundation-sites/js/foundation.core.js';
import { Sticky } from 'foundation-sites/js/foundation.sticky.js';

Foundation.addToJquery($);
Foundation.plugin(Sticky, 'Sticky');


export { Foundation };